(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "React", "loadjs", "ecCom", "jQuery", "ReactDOM", "$"], factory);
	else if(typeof exports === 'object')
		exports["ecCom"] = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else
		root["ecCom"] = factory(root["antd"], root["React"], root["loadjs"], root["ecCom"], root["jQuery"], root["ReactDOM"], root["$"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_58__, __WEBPACK_EXTERNAL_MODULE_586__, __WEBPACK_EXTERNAL_MODULE_658__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_213__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition